import feathersClient, { makeServicePlugin, BaseModel } from '@/plugins/feathers-client';

class ApiCampaignAnalytics extends BaseModel {
  constructor(data, options) {
    super(data, options)
  }
  static modelName = 'ApiCampaignAnalytics'
  static instanceDefaults() {
    return {}
  }
}

const servicePath = 'api/campaign-analytics';
const servicePlugin = makeServicePlugin({
  Model: ApiCampaignAnalytics,
  service: feathersClient.service(servicePath),
  servicePath
});

feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  }
});

export default servicePlugin;
